import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useRemoveQueryParams = () => {
  const router = useRouter();
  useEffect(() => {
    if (Object.keys(router.query).length > 0) {
      router.replace(
        {
          pathname: '/',
        },
        undefined,
        { shallow: true },
      );
    }
  }, [router]);
};
